// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1cDRl","choiceBoxes":"toolbarselects_choiceBoxes__2hBNW","simpleField":"toolbarselects_simpleField__RJYIk"};